import { ANALYTICS_ACTION, ANALYTICS_CATEGORY, ANALYTICS_LABEL } from "constants/loyalty-scan";
import Analytics from "@swiggy-private/analytics";

export const tapToClainClickEvent = (
    clickEvent: Analytics["clickEvent"],
    params: {
        cashbackEarned: string;
        expiryInDays: string;
        campaignId: number;
    },
): void => {
    clickEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        action: ANALYTICS_ACTION.TAP_TO_CLAIM,
        label: ANALYTICS_LABEL.TAP_TO_CLAIM_CLICK,
        context: JSON.stringify({
            cashbackEarned: params.cashbackEarned,
            expiryInDays: params.expiryInDays,
            campaignId: params.campaignId.toString(),
        }),
    });
};

export const eligibileScreenViewEvent = (
    screenViewEvent: Analytics["screenViewEvent"],
    params: {
        cashbackEarned: string;
        expiryInDays: string;
        campaignId: number;
        statusCode: number;
    },
): void => {
    screenViewEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        label: params.statusCode,
        context: JSON.stringify({
            cashbackEarned: params.cashbackEarned,
            expiryInDays: params.expiryInDays,
            campaignId: params.campaignId.toString(),
        }),
    });
};

export const exploreDineoutImpressionEvent = (
    impressionEvent: Analytics["impressionEvent"],
    params: {
        text: string;
        subText: string;
    },
): void => {
    impressionEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        action: ANALYTICS_ACTION.EXPLORE,
        label: ANALYTICS_LABEL.EXPLORE_IMPRESSION,
        context: JSON.stringify({
            text: params.text,
            subText: params.subText,
        }),
    });
};

export const exploreDineoutClickEvent = (
    clickEvent: Analytics["clickEvent"],
    params: {
        text: string;
        subText?: string;
    },
): void => {
    clickEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        action: ANALYTICS_ACTION.EXPLORE,
        label: ANALYTICS_LABEL.EXPLORE_CLICK,
        context: JSON.stringify({
            text: params.text,
            subText: params.subText,
        }),
    });
};

export const appDownloadClickEvent = (
    clickEvent: Analytics["clickEvent"],
    params: {
        device: string;
    },
): void => {
    clickEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        action: ANALYTICS_ACTION.DOWNLOAD_APP,
        label: params.device,
    });
};

export const clickLoginClickEvent = (
    clickEvent: Analytics["clickEvent"],
    params: {
        clickLogin: string;
    },
): void => {
    clickEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        action: ANALYTICS_ACTION.LOGIN,
        label: params.clickLogin,
    });
};

export const loginAndNonAppUserScreenViewEvent = (
    screenViewEvent: Analytics["screenViewEvent"],
    params: { cashbackEarned: string; campaignId: number; text: string },
): void => {
    screenViewEvent({
        category: ANALYTICS_CATEGORY.DO_CLAIM_CASHBACK,
        label: params.text,
        context: JSON.stringify({
            cashbackEarned: params.cashbackEarned,
            campaignId: params.campaignId.toString(),
        }),
    });
};
